//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {
      code: '', // input value
      codeLength: 6, // 验证码长度
      telDisabled: false, // 判断是否输入完
      focused: false // 让input焦点, 决定光标显示所在的位置
    }
  },
  computed: {
    codeArr () {
      // 将 input value 分隔数组 [1, 2, 3]
      return this.code.split('')
    },
    cursorIndex () {
      // 判断code输入长度，光标显示在对应label上
      return this.code.length
    }
  },
  methods: {
    handleChange (e) {
      console.warn(e)
    },
    handleClick (index) {
      if (this.code.length === 6) {
        this.telDisabled = false
        this.$refs.vcode.focus()
      }
    }
  },
  watch: {
    code (newVal) {
      // 限制 非数字
      this.code = newVal.replace(/[^\d]/g, '')
      if (newVal.length > 5) {
      // 禁用 input && 失去焦点 让键盘消失
        this.telDisabled = true
        this.$refs.vcode.blur()
        // submit !!!
        setTimeout(() => {
          this.$emit('submit', this.code)
        }, 500)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugin/LeonSimpleLogin/src/bl-input.vue